module.exports = __webpack_public_path__ + "img/ss_green-01.789e39dc.jpg";